import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p>Unit 3: Team 1 Project &copy; 2024 </p>
      <p>Yuliya Buiko / Roman Larionov / Tim Rodriguez / Mackenzie Wicker</p>
    </div>
  );
};

export default Footer;
